import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./logout.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./logout.component.scss?ngResource";
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AppControllerService } from 'src/app/app-controller.service';
import { AppConfig } from 'src/app/app.config';
import { AuthService } from 'src/app/shared/services/auth/auth.service';
let LogoutComponent = class LogoutComponent {
    router;
    appController;
    authService;
    appConfig;
    constructor(router, appController, authService, appConfig) {
        this.router = router;
        this.appController = appController;
        this.authService = authService;
        this.appConfig = appConfig;
    }
    static ctorParameters = () => [
        { type: Router },
        { type: AppControllerService },
        { type: AuthService },
        { type: AppConfig }
    ];
};
LogoutComponent = __decorate([
    Component({
        selector: 'app-logout',
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], LogoutComponent);
export { LogoutComponent };
